<template>
    <div class="widthBox mt_80">
        <div v-for="(item, index) in company_sub_list" :key="index">
            <h1 class="txt f-28 pb_40">{{ item.region }}</h1>
            <p class="info f-20 mt_40">{{ item.name }}</p>
            <el-row :gutter="10" class="acea-row row-between mb_32 mt_40">
                <el-col :span="4" :xs="12" class="txt_center">
                    <img :src="item.thumbnail_url" class="img100" alt="">
                </el-col>
            </el-row>
            <div class="acea-row row-between mb_80 infos"
                :class="item.web == '' && item.address == '' || item.enterprise_email == '' && item.address == '' || item.web == '' && item.address == '' ? 'row-center' : 'row-left'">
                <div v-if="item.enterprise_email != '' || item.products_after_sales_email != '' || item.member_support_email != ''" class="item">
                    <div class="info f-20">{{ $t("Email") }} </div>
                    <ul>
                        <li>{{ $t("Enterprise email") }}：{{ item.enterprise_email }}</li>
                        <li>{{ $t("Products after-sales email") }}：{{ item.products_after_sales_email }}</li>
                        <li>{{ $t("Member support email") }}：{{ item.member_support_email }}</li>
                    </ul>
                </div>
                <div v-if="item.web != ''" class="item">
                    <div class="info f-20">{{ $t("Tel") }} </div>
                    <ul>
                        <li>{{ item.web }}</li>
                    </ul>
                </div>
                <div v-if="item.address != '' || item.phone != ''" class="item">
                    <div class="info f-20">{{ $t("ADD") }} </div>
                    <ul>
                        <li>{{ item.address }}</li>
                        <li>{{ item.phone }}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-for="(item) in qa_type_list" :key="item.name" class="problems">
            <div class="name title txt_left">{{ item.name }}</div>
            <div v-for="(item2, index2) in item.qa_list" :key="index2" class="problem">
                <div class="acea-row row-between cursor" @click="item2.show = !item2.show">
                    <div class="info f-20 acea-row row-middle">
                        <img src="@/assets/problem.png" class="icon1 hidden-xs-only" alt="">
                        {{ item2.questions }}
                    </div>
                    <img v-show="!item2.show" src="@/assets/arrow_bottom2.png" class=" icon2" alt="">
                    <img v-show="item2.show" src="@/assets/arrow_top2.png" class=" icon2" alt="">
                </div>
                <div v-show="item2.show" class="answer info f-14">
                    {{ item2.answers }}
                </div>
            </div>
        </div>
        <div class="from">
            <el-row :gutter="10" class="acea-row row-between">
                <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="10" >
                    <p class="txt" style="margin-bottom: 16px;">{{$t("Contact Us")}}</p>
                    <div>
                        <input type="text" class="input" :placeholder="$t('Name') " v-model="from_data.name">
                        <input type="text" class="input" :placeholder="$t('Email')" v-model="from_data.email">
                        <input type="text" class="input" :placeholder="$t('Phone Number')" v-model="from_data.phone">
                        <input type="text" class="input" :placeholder="$t('address')" v-model="from_data.address">
                        <textarea v-model="from_data.content" class="input2" :placeholder="$t('Message')"></textarea>
                    </div>
                    <div class="btn cursor radius-4" @click="submit">{{ $t("Send maessage") }}</div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            from_data:{
                name:"",
                email:"",
                phone:"",
                content:"",
                address:""
            },
            company_sub_list:[],
            qa_type_list:[]
        }
    },
    created(){
        this.get_info();
    },
    methods:{
        async get_info(){
            let res = await this.$api.post("api/ContactUs/index", this.query);
            this.company_sub_list = res.data.company_sub_list
            res.data.qa_type_list.forEach(element => {
                element.qa_list.forEach(res => {
                    res.show = false;
                })
            });
            this.qa_type_list = res.data.qa_type_list
        },
        submit(){
            let vue_this = this;
            this.$api.post("api/ContactUs/message",this.from_data).then(res => {
                console.log(res.code)
                if(res.code == 200){
                    vue_this.$message({
                        message: res.msg,
                        type: 'success',
                        offset:"100"
                    });
                    vue_this.from_data = {
                        name:"",
                        email:"",
                        phone:"",
                        content:"",
                        address:""
                    }
                } else {
                    vue_this.$message({
                        message: res.msg,
                        type: 'error',
                        offset:"100"
                    });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.btn{
    font-size: 14px;
    color: #FFFFFF;
    padding: 12px 24px;
    background: #B50900;
    display: inline-block;
    margin-top: 16px;
}
.input{
    width: 100%;
    padding: 16px;
    font-size: 14px;
    margin-bottom: 16px;
    box-sizing: border-box;
    border: 1px solid #ccc;
}
.input2{
    width: 100%;
    padding: 16px;
    font-size: 14px;
    height: 200px;
    border: 1px solid #ccc;
    box-sizing: border-box;
}
.icon1 {
    width: 40px;
    height: 40px;
    vertical-align: top;
    margin-right: 15px;
}

.icon2 {
    width: 20px;
    height: 20px;
    vertical-align: top;
}

.problems {
    margin-bottom: 80px;

    .problem {
        padding: 24px 0;
        border-bottom: 1px solid #e6e6e6;
    }

    .answer {
        padding: 24px;
        background: #f5f5f5;
        margin-top: 24px;
    }

    .problem:last-child {
        border-bottom: 0px solid #e6e6e6;
    }
}

.pb_40 {
    padding-bottom: 40px;
    border-bottom: 1px solid #e6e6e6;
}

.mt_80 {
    margin-top: 80px;
}

.mb_80 {
    margin-bottom: 80px;
}

.mt_40 {
    margin-top: 40px;
}

.mb_32 {
    margin-bottom: 32px;
}

.mb_24 {
    margin-bottom: 24px;
}
ul{
    margin-top: 20px;
}
ul li {
    list-style: disc;
    color: #666666;
    font-size: 14px;
    position: relative;
    left: 14px;
    text-align: left;
    margin-bottom: 12px;
}

.infos {
    .item {
        width: 33%;
    }
}

@media screen and(max-width:1000px) {

    .infos {
        .item {
            width: 100%;
            margin-top: 20px;

            .info {
                margin-bottom: 16px;
            }
        }
    }
}

@media screen and(max-width:768px) {
    .mt_80 {
        margin-top: 40px;
    }

    .pb_40 {
        padding-bottom: 20px;
    }

    .mt_40 {
        margin-top: 20px;
    }

    .mb_32 {
        margin-bottom: 20px;
    }

    .mb_80 {
        margin-bottom: 40px;
    }
}</style>